import React from "react";
import { Modal, Table } from "react-bootstrap";
import { calcParkingBreakdown } from "../../../HELPERS/parkingStays"; // adjust path to match your tree

// Display-only formatter: "2026-06-29 12:02:44" -> "29 Jun 2026"
const formatDateOnly = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr; // fallback if parsing fails
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const ParkingDetailsModal = ({ show, onHide, movements, checkin_date, checkout_date, parking_price }) => {
  const { segments } = calcParkingBreakdown(movements, parking_price, checkin_date, checkout_date);
  const formatCurrency = (v) => Number(v || 0).toFixed(2);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Parking Breakdown</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {segments.length === 0 ? (
          <p className="text-muted mb-0">No billable parking periods yet.</p>
        ) : (
          <Table size="sm" bordered>
            <thead>
              <tr>
                <th>Period</th>
                <th>Vehicles Parked</th>
                <th>Days</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {segments.map((s, i) => (
                <tr key={i}>
                  <td>
                    {formatDateOnly(s.from)} &rarr; {formatDateOnly(s.to)}
                    {s.current && <span className="text-success ms-1">(current)</span>}
                  </td>
                  <td>{s.vehicles}</td>
                  <td>{s.days}</td>
                  <td className="text-end">{formatCurrency(s.amount)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ParkingDetailsModal;